import React from "react";

import { Trans } from "@lingui/react/macro";

import Link from "@readai/common/components/Link";
import LINKS from "@readai/common/links";
import Stack from "@readai/pulse/components/Stack";

import EventNotification, {
  EventNotificationDescription,
  EventNotificationTitle,
  ReturnToRead,
} from "@app/booking/components/EventNotification";

const EventError = () => (
  <EventNotification>
    <Stack spacing={1}>
      <EventNotificationTitle>
        <Trans>Oops!</Trans>
      </EventNotificationTitle>
      <EventNotificationDescription>
        <Trans>
          The event you are trying to view cannot be accessed at this time.
          Please reach out to the calendar owner or contact{" "}
          <Link href={LINKS.EMAIL.SUPPORT}>support@read.ai</Link> if the problem
          persists.
        </Trans>
      </EventNotificationDescription>
    </Stack>
    <ReturnToRead />
  </EventNotification>
);

export default EventError;
